import React from "react"
import { Link } from "gatsby"
import Header from "../components/header"
import Footer from "../components/footer"
import { IconIndustry911, IconIndustryLaw, IconIndustryEMS, IconIndustryFire, IconResponseAutomate, IconResponseChat,
  IconResponseSurveys, IconResponseMeasure, IconPlay } from "../components/icons"
import "../styles/styles.sass"
import { Helmet } from 'react-helmet'
import Img from "gatsby-image"
import { ImageLandingCPSS } from "../components/images"
import ReactPlayer from 'react-player'
import { useStaticQuery, graphql } from "gatsby"

export default function Home() {
  const data = useStaticQuery(graphql`
    query MyQuery {
      file(relativePath: { eq: "imageLandingHero.jpg" }) {
        childImageSharp {
          fluid (maxWidth: 3080, quality: 95){
            aspectRatio
            base64
            sizes
            src
            srcSet
          }
        }
      }
    }
  `)

  return (
    <div className="landingView landingIndexView">
      <Helmet>
        <html lang="en" />
        <title>CueHit - Reshaping Citizen Connections for Public Safety</title>
        <description>A complete Community Engagement solution for 9-1-1, Law Enforcement and Fire/EMS.</description>
        <link rel="icon" href={'/favicon.ico'} />
      </Helmet>

      <Header />
      
      <div className="landingContent">
        <section className="landingSection heroSection">
          <div className="heroBanner">
            <h1 className="heroTitle">Reshaping Citizen Connections for Public Safety</h1>
            <p className="heroSubtitle">A complete Community Engagement solution for 9-1-1, Law Enforcement and Fire/EMS.</p>
            <div className="heroActions">
              <Link to="#responseSection" className="actionItem secondary">
                <div className="actionTitle">Learn More</div>
              </Link>

              <Link to="/contact" className="actionItem primary">
                <div className="actionTitle">Request a Demo</div>
              </Link>
            </div>
          </div>
          <Img
            fluid={data.file.childImageSharp.fluid}
            alt="A person holding smartphone with various chart, blurred city lights in the background"
            className="heroImage"
          />
        </section>

        <section className="landingSection videosSection">
          <div className="videosContainer">
            <div className="sectionHeader">
              <h1 className="sectionTitle">The Power of Citizen Satisfaction Surveys in CueHit</h1>
            </div>

            <div className="videoCell">
              <ReactPlayer
                  url="https://www.youtube.com/embed/ME8wSXlbpRE?controls=0" frameborder="0"
                  width="100%"
                  height="100%"
                  playing
                  playIcon={(<div className="playButton">
                    <IconPlay />
                  </div>)}
                  light="/imageLandingVideoPreview.jpg"
              />
            </div>
          </div>
        </section>

        <section className="landingSection satisfactionSection">
          <div className="satisfactionContainer">
            <div className="sectionHeader">
              <h1 className="sectionTitle">What is your department’s Citizen Positive Satisfaction Score?</h1>
            </div>

            <div className="sectionDetails">
              <div className="satisfactionImage">
                <ImageLandingCPSS />
              </div>
              <p className="sectionFootnote">The CueHit Positive Satisfaction Score (CPSS) is a calculation based on Scale questions from 1-5 that you send to your citizens.</p>
            </div>
          </div>
        </section>

        {/*<section className="landingSection missionSection">*/}
        {/*  <div className="missionContainer">*/}

        {/*    <div className="missionGrid">*/}
        {/*      <div className="missionSectionTitle">The CueHit Solution</div>*/}
        {/*      */}
        {/*      <div className="missionArtwork">*/}
        {/*        <img*/}
        {/*          src="/imageLandingMission.png"*/}
        {/*          alt="" */}
        {/*          width="100%" height="auto"*/}
        {/*          style={{ maxWidth: '1024px', maxHeight: '356px', minWidth: '1024px', minHeight: '356px' }}*/}
        {/*        />*/}
        {/*      </div>*/}

        {/*      <div className="missionGridItem item1">*/}
        {/*        <div className="mockMissionArtwork">*/}
        {/*          <img*/}
        {/*            src="/imageLandingMissionMock.png"*/}
        {/*            width="100%" height="auto"*/}
        {/*            style={{ maxWidth: '320px', maxHeight: '356px', minWidth: '320px', minHeight: '356px' }}*/}
        {/*          />*/}
        {/*        </div>*/}
        {/*        <div className="missionOrder"><h3 className="orderValue">1</h3></div>*/}
        {/*        <h3 className="missionTitle">Connect Your Tools</h3>*/}
        {/*      </div>*/}

        {/*      <div className="missionGridItem item2">*/}
        {/*        <div className="mockMissionArtwork">*/}
        {/*          <img*/}
        {/*            src="/imageLandingMissionMock.png"*/}
        {/*            width="100%" height="auto"*/}
        {/*            style={{ maxWidth: '320px', maxHeight: '356px', minWidth: '320px', minHeight: '356px' }}*/}
        {/*          />*/}
        {/*        </div>*/}
        {/*        <div className="missionOrder"><h3 className="orderValue">2</h3></div>*/}
        {/*        <h3 className="missionTitle">Set Up Your Rules</h3>*/}
        {/*      </div>*/}

        {/*      <div className="missionGridItem item3">*/}
        {/*        <div className="mockMissionArtwork">*/}
        {/*          <img*/}
        {/*            src="/imageLandingMissionMock.png"*/}
        {/*            width="100%" height="auto"*/}
        {/*            style={{ maxWidth: '320px', maxHeight: '356px', minWidth: '320px', minHeight: '356px' }}*/}
        {/*          />*/}
        {/*        </div>*/}
        {/*        <div className="missionOrder"><h3 className="orderValue">3</h3></div>*/}
        {/*        <h3 className="missionTitle">Automate Communication</h3>*/}
        {/*      </div>*/}
        {/*    </div>*/}

        {/*  </div>*/}
        {/*</section>*/}

        <section className="landingSection industriesSection">
          <div className="industriesContainer">
            <div className="sectionHeader">
              <h1 className="sectionTitle">Community-Centric Solutions</h1>
            </div>

            <div className="industriesGrid">
              <Link to="/911/" className="industryGridItem industry911">
                <div className="industryIcon">
                  <IconIndustry911 />
                </div>
                <h2 className="industryTitle">911</h2>
                <p className="industryBody">Configure your virtual assistant with data from 911 and CAD to automate delivery of texts and surveys to  callers.</p>
                <div className="industryAction">
                  <div className="actionTitle">Learn More</div>
                </div>
              </Link>

              <Link to="/law-enforcement/" className="industryGridItem industryLaw">
                <div className="industryIcon">
                  <IconIndustryLaw />
                </div>
                <h2 className="industryTitle">Law Enforcement</h2>
                <p className="industryBody">The tools you need to help engage your community and proactively measure the satisfaction levels of your citizens and take corrective action.</p>
                <div className="industryAction">
                  <div className="actionTitle">Learn More</div>
                </div>
              </Link>

              <Link to="/ems/" className="industryGridItem industryEMS">
                <div className="industryIcon">
                  <IconIndustryEMS />
                </div>
                <h2 className="industryTitle">EMS</h2>
                <p className="industryBody">The full EMS workflow solution for Alternative Treatment and Transport.</p>
                <div className="industryAction">
                  <div className="actionTitle">Learn More</div>
                </div>
              </Link>

              <Link to="/fire/" className="industryGridItem industryFire">
                <div className="industryIcon">
                  <IconIndustryFire />
                </div>
                <h2 className="industryTitle">Fire Rescue</h2>
                <p className="industryBody">The direct connection to Community Risk Reduction and Firefighter Wellness.</p>
                <div className="industryAction">
                  <div className="actionTitle">Learn More</div>
                </div>
              </Link>
            </div>
          </div>
        </section>
      </div>

      <Footer/>

    </div>
  )
}
